var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "opt-group" }, [
    _c("div", { staticClass: "center-content" }, [
      _vm.record.authStatus == "0"
        ? _c(
            "i",
            {
              staticClass: "iconBtn el-icon-time",
              staticStyle: { color: "orange" },
              attrs: { title: _vm.$t("status.applying") },
            },
            [_vm._v(_vm._s(_vm.$t("status.applying")))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.record.authStatus == "1"
        ? _c(
            "i",
            {
              staticClass: "iconBtn el-icon-time",
              staticStyle: { color: "#0c91e5" },
              attrs: { title: _vm.$t("status.approving") },
            },
            [_vm._v(_vm._s(_vm.$t("status.approving")))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.record.authStatus == "2"
        ? _c(
            "i",
            {
              staticClass: "iconBtn el-icon-time",
              staticStyle: { color: "#0c91e5" },
              attrs: { title: _vm.$t("status.approved") },
            },
            [_vm._v(_vm._s(_vm.$t("status.approved")))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.record.authStatus == "3"
        ? _c(
            "i",
            {
              staticClass: "iconBtn el-icon-error",
              staticStyle: { color: "red" },
              attrs: { title: _vm.$t("status.reject") },
            },
            [_vm._v(_vm._s(_vm.$t("status.reject")))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.record.authStatus == "4"
        ? _c(
            "i",
            {
              staticClass: "iconBtn el-icon-error",
              staticStyle: { color: "red" },
              attrs: { title: _vm.$t("com.invalid") },
            },
            [_vm._v(_vm._s(_vm.$t("com.invalid")))]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }